import { onINP } from 'web-vitals/attribution';

function logSlowINPWhenTrackJSAvailable(metric) {
    if (metric.value <= 200) return; // Ignore good responsiveness

    if (window.TrackJS) {
        window.TrackJS.console.log({
            metricValue: metric.value,
            interactionTarget: metric.attribution.interactionTarget,
            interactionTargetElement: metric.attribution.interactionTargetElement,
        });
        window.TrackJS.track(new Error(`Slow INP detected`));
    }
}

if (window.requestIdleCallback) {
    requestIdleCallback(() => {
        onINP(logSlowINPWhenTrackJSAvailable, { reportAllChanges: true });
    });
} else {
    setTimeout(() => {
        onINP(logSlowINPWhenTrackJSAvailable, { reportAllChanges: true });
    }, 0);
}
